import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=1598b4f6"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=1598b4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports